import React, { useCallback, useState } from 'react';
import { CreateReport } from '../../../components';
import { paths } from '../../../routes';
import * as Yup from 'yup';

export const AsctForms: React.FC = () => {
  const [concomitance, setConcomitance] = useState(false);

  const handleOnChange = useCallback(
    (form) => {
      const concomitanceValue = form?.values?.fieldReportsDto.equipment.concomitance;
      const { setFieldValue } = form;

      if (concomitanceValue !== concomitance) {
        setConcomitance(() => {
          if (concomitance) {
            setFieldValue('fieldReportsDto.equipment.trainConcomitantNumber', '');
          }
          return concomitanceValue;
        });
      }
    },
    [concomitance]
  );
  return (
    <CreateReport
      initialValues={{
        fieldReportsDto: {
          equipment: {
            compliantLayout: true,
          },
          resourceInformation: {
            isEscalAgent: true,
            securityOfficerOne: true,
            securityOfficerTwo: false,
          },
          tools: {
            synchronization: true,
            isOperationalGateBoarding: true,
            phonePickup: true,
            astCall: true,
          },
          boardingReception: {
            allCustomerScanned: true,
            aeStarting: true,
            nrbCustomerScanned: 0,
            nbrRegularization: 0,
            nbrReport: 0,
          },
        },
      }}
      themeShortCode={paths.aetgv.themeShortCode || ''}
      otherFields={{
        section1: {
          type: 'section',
          name: 'section',
          label: 'MATÉRIEL',
        },
        'fieldReportsDto.equipment.initialDeparture': {
          type: 'date',
          label: 'Départ initial',
          grid: 6,
        },
        serviceType: {
          type: 'radio',
          name: 'stationType',
          label: 'Type de train',
          options: [
            {
              value: 'US',
              label: 'US',
            },
            {
              value: 'UM',
              label: 'UM',
            },
            {
              value: 'US+ HLP',
              label: 'US+ HLP',
            },
          ],
          grid: 6,
        },
        'fieldReportsDto.equipment.compliantLayout': {
          type: 'switch',
          label: 'Agencement conforme',
          grid: 12,
          initialValue: true,
        },
        'fieldReportsDto.equipment.nbrClientUp': {
          type: 'number',
          label: 'Nombre de clients à la montée',
          initialValue: 0,
          grid: 6,
        },
        'fieldReportsDto.equipment.nbrClientDown': {
          type: 'number',
          label: 'Nombre de clients à la descente',
          initialValue: 0,
          grid: 6,
        },
        'fieldReportsDto.equipment.concomitance': {
          type: 'switch',
          label: 'Concomitance',
          grid: 6,
        },
        'fieldReportsDto.equipment.trainConcomitantNumber': {
          type: 'text',
          name: 'numberTrainConcomitant',
          label: 'Numero de train concomitant',
          disabled: !concomitance,
          grid: 6,
        },
        section2: {
          type: 'section',
          name: 'section',
          label: 'CLIENTÈLE ACCÉS +',
        },
        'fieldReportsDto.customerAccess.isConform': {
          type: 'switch',
          name: 'pmr',
          label: 'PMR/YFR/PSH conforme',
          grid: 6,
          initialValue: true,
        },
        'fieldReportsDto.customerAccess.isHead': {
          type: 'radio',
          name: 'ram',
          label: 'Rame de',
          grid: 6,
          options: [
            {
              value: 'true',
              label: 'Tête',
            },
            {
              value: 'false',
              label: 'Queue',
            },
          ],
        },
        'fieldReportsDto.customerAccess.carriage': {
          type: 'text',
          name: 'voiture',
          label: 'Voiture',
          grid: 6,
        },
        'fieldReportsDto.customerAccess.place': {
          type: 'text',
          name: 'place',
          label: 'Place',
          grid: 6,
        },
        section3: {
          type: 'section',
          label: 'INFORMATION SUR LES RESSOURCES',
        },
        'fieldReportsDto.resourceInformation.isEscalAgent': {
          type: 'switch',
          label: "Agent d'escale",
          grid: 6,
          initialValue: true,
        },
        'fieldReportsDto.resourceInformation.post': {
          type: 'text',
          label: 'Poste non tenu Escale',
          grid: 6,
        },
        'fieldReportsDto.resourceInformation.securityOfficerOne': {
          type: 'switch',
          label: 'Agent de sécurité 1',
          grid: 6,
          initialValue: true,
        },
        'fieldReportsDto.resourceInformation.securityOfficerTwo': {
          type: 'switch',
          label: 'Agent de sécurité 2',
          grid: 6,
          initialValue: true,
        },
        'fieldReportsDto.resourceInformation.nbrASTPresent': {
          type: 'number',
          label: "Nombre d'ASCT présents H-50",
          initialValue: 0,
          grid: 6,
        },
        'fieldReportsDto.resourceInformation.nbrASTPresentArrival': {
          type: 'number',
          label: "Nombre d'ASCT présents à l'arrivée",
          initialValue: 0,
          grid: 6,
        },
        section4: {
          type: 'section',
          name: 'section',
          label: 'OUTILS',
        },
        'fieldReportsDto.tools.synchronization': {
          type: 'switch',
          name: 'synchronisation',
          label: 'Synchronisation PDA/CECIL',
          grid: 6,
        },
        'fieldReportsDto.tools.isOperationalGateBoarding': {
          type: 'switch',
          label: "Portes d'embarquements opérationnelles",
          grid: 6,
        },
        'fieldReportsDto.tools.phonePickup': {
          type: 'switch',
          label: 'Prise du téléphone coordinateur',
          grid: 6,
        },
        'fieldReportsDto.tools.astCall': {
          type: 'switch',
          label: 'Appel ASCT du tain impair à H-30',
          grid: 6,
        },
        section5: {
          type: 'section',
          name: 'section',
          label: 'ACCUEIL EMBARQUEMENT',
        },
        'fieldReportsDto.boardingReception.allCustomerScanned': {
          type: 'switch',
          label: '100% Des clients présents scannés',
          grid: 6,
        },
        'fieldReportsDto.boardingReception.aeStarting': {
          type: 'switch',
          label: "Début de l'A/E à H-50",
          grid: 6,
        },
        'fieldReportsDto.boardingReception.deviation': {
          type: 'switch',
          label: 'Dévoiement inopiné',
          grid: 6,
        },
        'fieldReportsDto.boardingReception.trainDelay': {
          type: 'switch',
          label: 'Retard du train précédent',
          grid: 6,
        },
        'fieldReportsDto.boardingReception.changeTools': {
          type: 'switch',
          label: 'Changement de matériel',
          grid: 6,
        },
        'fieldReportsDto.boardingReception.lateDocking': {
          type: 'switch',
          label: 'Mise à quai tardive',
          grid: 6,
        },
        'fieldReportsDto.boardingReception.nrbCustomerScanned': {
          type: 'number',
          label: 'Nombre de clients scannés',
          initialValue: 0,
          grid: 6,
        },
        'fieldReportsDto.boardingReception.nbrRegularization': {
          type: 'number',
          label: 'Nombre de régularisations',
          initialValue: 0,
          grid: 6,
        },
        'fieldReportsDto.boardingReception.nbrReport': {
          type: 'number',
          label: 'Nombre de signalements',
          initialValue: 0,
          grid: 6,
        },
        section6: {
          type: 'section',
          label: 'COMMENTAIRE',
          name: 'commentaire',
        },

        'fieldReportsDto.comment': {
          type: 'text',
          label: 'Exposer les faits',
          multiline: true,
          rows: 4,
          rowsMax: 15,
        },
      }}
      onChange={handleOnChange}
      validationSchema={Yup.object({
        serviceName: Yup.string().required('Ce champ est requis').nullable(),
        fieldReportsDto: Yup.object({
          equipment: Yup.object({
            trainConcomitantNumber: Yup.number()
              .typeError('Ce champ doit être un nombre')
              .nullable(),
          }),
          customerAccess: Yup.object({
            carriage: Yup.number().typeError('Ce champ doit être un nombre'),
            place: Yup.number().typeError('Ce champ doit être un nombre'),
          }),
        }),
      })}
    />
  );
};

export default AsctForms;
